export default "__VITE_ASSET__DzMLOyzR__"